var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2374 24.0514L20.2207 18.0347C21.0774 16.7714 21.5927 15.2561 21.6214 13.6194C21.6994 9.12939 18.1101 5.41272 13.6201 5.33406C9.11808 5.27672 5.41341 8.84605 5.33474 13.3354C5.25674 17.8254 8.84608 21.5421 13.3361 21.6207C13.3841 21.6214 13.4321 21.6221 13.4801 21.6221C15.1641 21.6221 16.7321 21.1041 18.0354 20.2201L24.0514 26.2361L26.2374 24.0514ZM13.4801 19.3334C13.4454 19.3334 13.4107 19.3334 13.3767 19.3327C10.1487 19.2761 7.56808 16.6041 7.62408 13.3761C7.68008 10.1821 10.2954 7.62272 13.4774 7.62272C13.5114 7.62272 13.5467 7.62272 13.5807 7.62339C16.8087 7.68006 19.3894 10.3521 19.3334 13.5801C19.2767 16.7734 16.6614 19.3334 13.4801 19.3334Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSearch);
export default __webpack_public_path__ + "static/media/icons-search.92651e40adebfc2263c7e6fe7e9a2cae.svg";
export { ForwardRef as ReactComponent };